module.exports = __webpack_public_path__ + "static/media/leather_jeff.3bb92f0b.jpg";